var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxReset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1251_81013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2.375C8.14 2.375 6.4 3.025 5 4.205V2.875C5 2.46079 4.66421 2.125 4.25 2.125C3.83579 2.125 3.5 2.46079 3.5 2.875V6.075C3.5 6.35503 3.5 6.49504 3.5545 6.602C3.60243 6.69608 3.67892 6.77257 3.773 6.8205C3.87996 6.875 4.01997 6.875 4.3 6.875H7.5C7.91421 6.875 8.25 6.53921 8.25 6.125C8.25 5.71079 7.91421 5.375 7.5 5.375H5.94C7.07 4.405 8.49 3.875 10 3.875C13.45 3.875 16.25 6.675 16.25 10.125C16.25 13.575 13.45 16.375 10 16.375C6.80334 16.375 4.16472 13.9711 3.79444 10.8736C3.74528 10.4624 3.41421 10.125 3 10.125C2.58579 10.125 2.24618 10.4618 2.28599 10.8741C2.66459 14.7946 5.98265 17.875 10 17.875C14.27 17.875 17.75 14.395 17.75 10.125C17.75 5.855 14.27 2.375 10 2.375Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1251_81013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5,
    height: 15.75,
    fill: "white",
    transform: "translate(2.25 2.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxReset);
export default __webpack_public_path__ + "static/media/icon_20px_reset.9408c66c1d210d5838cf6ece2ede9c6c.svg";
export { ForwardRef as ReactComponent };